import React from "react";

export const UserHome = () => {
  return (
    <div className="flex mt-20 mb-40 justify-center items-center">Home</div>
  );
};
